<template>
  <div v-viewer="options">
    <ul class="image-list clearfix">
      <li v-for="item in images" :key="item.content_id">
        <img
          :src="item.image"
          :data-source="item.image"
          class="image"
          :key="item.image"
          :alt="item.image.split('?image=').pop()"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import _ from 'underscore';
const picExt = [
  'png',
  'jpg',
  'jpeg',
  'bmp',
  'gif',
  'avi',
  'mov',
  'rmvb',
  'mp4',
  'rm',
];
export default {
  props: {
    sourceImages: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      options: {
        toolbar: true,
        url: 'data-source',
        navbar: false,
        title: false,
      },
      // images: [...sourceImages].splice(0, 5)
    };
  },
  computed: {
    images() {
      return this.sourceImages;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.image-list {
  margin-bottom: 60px;
  padding: 0 10px;
  li {
    float: left;
    width: 340px;
    margin: 0 10px 20px 10px;
    cursor: pointer;
    img {
      width: 340px;
      height: 220px;
    }
  }
}
</style>
